import React from 'react';
import fr from 'facet-rest';
import moment from 'moment/moment';


// eslint-disable-next-line react/prop-types
function DangerousReadOnlyRichText({ value }) {
  return (<div
    style={{
      margin: '0',
      padding: '6px 0px 7px',
      color: '#606060',
    }}
     /* eslint-disable-next-line react/no-danger */
    dangerouslySetInnerHTML={{ __html: value }}
  />);
}

// eslint-disable-next-line react/prop-types
function DangerouslySetDateFormat({ value }) {
  const displayTime = moment(value).format('MM-DD-YYYY');
  /* eslint-disable */
  return (<p style={{
    fontSize: '16px', margin: '0', padding: '6px 0px 7px', color: '#606060',
  }}

  >
    {displayTime}
          </p>);
}
/* eslint-enable */
export const metaOverrideSet = fr.metaOverride()
  .nameOverride('description', {
    _component: () => DangerousReadOnlyRichText,
    display: true,
    _hideLabel: true,
    hidden: false,
  })
  .overrideAll({
    _hideLabel: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('name', {
    display: true,
    readonly: true,
    _hideLabel: true,
    hidden: false,
  })
  .nameOverride('priority', {
    display: true,
    readonly: true,
    hidden: false,
  })
  .nameOverride('dueDate', {
    display: true,
    hidden: false,
    _component: () => DangerouslySetDateFormat,
  });
